import React from 'react';

const TypeSelector = ({svg, name, highlighted}) => {
    return (
        <li className='li-d-d' style={{padding: '15px'}}>
            <div style={{
                color: highlighted ? '#40a629' : '', marginBottom: '10px', display: "flex", justifyContent:
                    "center"
            }}>
                {svg}
            </div>
            <div style={{color: highlighted ? '#414141' : '#808080', fontSize: '14px', marginTop: '5px'}}>
                {name}
            </div>
        </li>
    );
};

export default TypeSelector;